import { ChainId } from '@/config/constants/chainId';
import { RPC } from '@/config/constants/rpc';
import { Web3Provider } from '@ethersproject/providers';
import { InjectedConnector } from '@web3-react/injected-connector';
import { WalletConnectConnector } from '@web3-react/walletconnect-connector';
import { NetworkConnector } from './NetworkConnector';

export const network = new NetworkConnector({
  defaultChainId: Number(process.env.REACT_APP_CHAINID),
  urls: RPC,
});

let networkLibrary: Web3Provider | undefined;
export function getNetworkLibrary(): Web3Provider {
  return (networkLibrary = networkLibrary ?? new Web3Provider(network.provider as any));
}

export const POLLING_INTERVAL = 12000;
export const injected = new InjectedConnector({
  supportedChainIds: Object.values(ChainId),
});
export const NetworkContextName = 'NETWORK';
export const connectorLocalStorageKey = 'connectorId';

export const walletConnector = new WalletConnectConnector({
  supportedChainIds: Object.values(ChainId),
  rpc: RPC,
  qrcode: true,
});
